import * as React from "react";

import { Testimonials, TestimonialsData } from "../Testimonials";

import {
  Head,
  HowItWorks,
  Advantages,
  Staff,
  AdvantagesData,
  HeadData,
  HowItWorksData,
  StaffData,
} from "./sections";

export interface PageApplyPrismicData
  extends StaffData,
    HeadData,
    HowItWorksData,
    AdvantagesData,
    TestimonialsData {}

interface Props {
  prismicData?: { data: PageApplyPrismicData };
  showStaffImage?: boolean;
}

const ApplyPage = (props: Props): React.ReactElement => {
  const headData: HeadData = {
    hero_title: props.prismicData?.data.hero_title,
    hero_description: props.prismicData?.data.hero_description,
    hero_action_button: props.prismicData?.data.hero_action_button,
    hero_action_button_link: props.prismicData?.data.hero_action_button_link,
    hero_image: props.prismicData?.data.hero_image,
    hero_image_mobile: props.prismicData?.data.hero_image_mobile,
  };

  const howItWorksData: HowItWorksData = {
    // prismic
    how_it_works_title: props.prismicData?.data.how_it_works_title,
    how_it_works_step_one_description:
      props.prismicData?.data.how_it_works_step_one_description,
    how_it_works_step_one_icon:
      props.prismicData?.data.how_it_works_step_one_icon,
    how_it_works_step_two_description:
      props.prismicData?.data.how_it_works_step_two_description,
    how_it_works_step_two_icon:
      props.prismicData?.data.how_it_works_step_two_icon,
    how_it_works_step_three_description:
      props.prismicData?.data.how_it_works_step_three_description,
    how_it_works_step_three_icon:
      props.prismicData?.data.how_it_works_step_three_icon,
  };

  const advantagesData: AdvantagesData = {
    // prismic
    advantages_title: props.prismicData?.data.advantages_title,
    advantages_list: props.prismicData?.data.advantages_list,
    advantages_action_button: props.prismicData?.data.advantages_action_button,
    advantages_action_button_link:
      props.prismicData?.data.advantages_action_button_link,
  };

  const staffData: StaffData = {
    //prismic
    staff_image: props.prismicData?.data.staff_image,
  };

  const testimonialsData: TestimonialsData = {
    // prismic
    testimonials_title: props.prismicData?.data.testimonials_title,
    testimonials_list: props.prismicData?.data.testimonials_list,
  };

  return (
    <React.Fragment>
      <Head data={headData} />
      <HowItWorks data={howItWorksData} />
      <Advantages data={advantagesData} />
      {props.showStaffImage && <Staff data={staffData} />}
      <Testimonials data={testimonialsData} />
    </React.Fragment>
  );
};

export { ApplyPage };
